export const YEAR_SEMESTER_ID = 33
export const ELECTIVE_SUMMER_SEMESTER = false
export const HOW_MANY_FUTURE_SEMESTERS = 1
export const CHOICES_ENABLED = false